import React from 'react'
import { useTranslation } from 'react-i18next'

import alertIcon from 'assets/images/sprite/message-alert-red-icon.svg'

import { StyledIgnoredSigns as S } from './IgnoredSigns.styles'
import { IGNORED_SIGNS_KEYS } from './constants'

export const IgnoredSigns: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Title>{t('onboarding.landingWellness.ignoredSigns.title')}</S.Title>

      <S.List>
        {IGNORED_SIGNS_KEYS.map((titleKey) => (
          <S.Sign key={titleKey}>
            <S.SignIcon svg={alertIcon} width={32} height={32} />
            <S.SignTitle>{t(titleKey)}</S.SignTitle>
          </S.Sign>
        ))}
      </S.List>
    </S.Wrapper>
  )
}
